import { AdminApiClient, ApiError } from "@custos/api-client";
import { QueryClient } from "@tanstack/react-query";
import { useAuth } from "./auth";

/** Admin API client: access token in memory, refresh token in the httpOnly admin cookie. */
export const api = new AdminApiClient({
  baseUrl: import.meta.env.VITE_API_URL || "/api",
  transport: "cookie",
  onSessionExpired: () => useAuth.getState().sessionExpired(),
});

api.onAuthChange((loggedIn) => {
  if (loggedIn) useAuth.getState().setAuthenticated();
  else useAuth.getState().setAnonymous();
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      retry: (count, error) =>
        count < 2 && !(error instanceof ApiError && error.status >= 400 && error.status < 500),
      refetchOnWindowFocus: true,
    },
  },
});
